import { StoredDatePart } from "src/app/storage/models/stored-utilities/stored-date-part";

/**
 * An instance of the StoredDatePart model to be used for schema validation
 */
export const storedDatePartInstance: StoredDatePart = {
	Year: 0,
	Month: 0,
	Day: 0
}